import { Navigate } from "react-router-dom";
import { useAuth, canEdit } from "../../lib/auth";

export default function ProtectedAdmin({ children, requireSuper = false, requireEdit = false }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen bg-aawta-jet flex items-center justify-center">
        <div className="w-10 h-10 border-2 border-aawta-pink border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  if (requireSuper && user.role !== "super_admin") return <Navigate to="/admin" replace />;
  if (requireEdit && !canEdit(user)) return <Navigate to="/admin" replace />;
  return children;
}
